/*
 * Gentle Morrow - product finder quiz.
 *
 * Scores each product across five questions and recommends the winner, with
 * the runner-up shown underneath so the answer never feels like a black box.
 * Ties resolve to the bundle, which is the honest answer when someone wants
 * both blackout and eyes-free on different nights.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var data, products;
    try {
      data = JSON.parse(root.querySelector('[data-gm-quiz-questions]').textContent);
      products = JSON.parse(root.querySelector('[data-gm-quiz-products]').textContent);
    } catch (e) {
      return;
    }

    var step = 0;
    var scores = {};
    var history = [];

    var elBar = root.querySelector('[data-gm-bar]');
    var elStep = root.querySelector('[data-gm-step]');
    var elQ = root.querySelector('[data-gm-q]');
    var elSub = root.querySelector('[data-gm-sub]');
    var elOpts = root.querySelector('[data-gm-opts]');
    var elBack = root.querySelector('[data-gm-back]');

    function render() {
      var q = data[step];
      elBar.style.width = Math.round((step / data.length) * 100) + '%';
      elStep.textContent = 'Question ' + (step + 1) + ' of ' + data.length;
      elQ.textContent = q.q;
      elSub.textContent = q.sub || '';
      elSub.hidden = !q.sub;
      elOpts.innerHTML = '';

      q.a.forEach(function (opt, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gm-quiz__opt';
        b.innerHTML =
          '<span class="gm-quiz__dot" aria-hidden="true"></span>' +
          '<span><span class="gm-quiz__ot"></span>' +
          (opt.d ? '<span class="gm-quiz__od"></span>' : '') +
          '</span>';
        b.querySelector('.gm-quiz__ot').textContent = opt.t;
        if (opt.d) b.querySelector('.gm-quiz__od').textContent = opt.d;
        b.addEventListener('click', function () {
          choose(i);
        });
        elOpts.appendChild(b);
      });

      elBack.hidden = step === 0;
    }

    function choose(i) {
      var picked = data[step].a[i];
      history.push(picked.s || {});
      Object.keys(picked.s || {}).forEach(function (k) {
        scores[k] = (scores[k] || 0) + picked.s[k];
      });
      step += 1;
      if (step >= data.length) finish();
      else render();
    }

    elBack.addEventListener('click', function () {
      if (step === 0) return;
      step -= 1;
      var undo = history.pop() || {};
      Object.keys(undo).forEach(function (k) {
        scores[k] -= undo[k];
      });
      render();
    });

    function rank() {
      return Object.keys(products)
        .map(function (k) {
          return { key: k, score: scores[k] || 0 };
        })
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          // a genuine tie means they want both - the bundle is the honest answer
          if (a.key === 'bundle') return -1;
          if (b.key === 'bundle') return 1;
          return 0;
        });
    }

    function finish() {
      var order = rank();
      var win = products[order[0].key];
      var alt = products[order[1].key];
      if (!win) return;

      root.querySelector('[data-gm-rimg]').src = win.image || '';
      root.querySelector('[data-gm-rimg]').alt = win.title;
      root.querySelector('[data-gm-rname]').textContent = win.title;
      root.querySelector('[data-gm-rprice]').innerHTML =
        (win.compare ? '<span class="gm-quiz__cwas">' + win.compare + '</span>' : '') + win.price;
      root.querySelector('[data-gm-rwhy]').innerHTML = win.why;
      var cta = root.querySelector('[data-gm-rcta]');
      cta.href = win.url;
      cta.textContent = 'View the ' + win.short;

      if (alt) {
        root.querySelector('[data-gm-aimg]').src = alt.image || '';
        root.querySelector('[data-gm-aimg]').alt = alt.title;
        var an = root.querySelector('[data-gm-aname]');
        an.textContent = alt.title;
        an.href = alt.url;
        root.querySelector('[data-gm-aprice]').textContent = alt.price;
      }

      elBar.style.width = '100%';
      root.classList.add('is-done');
      var head = root.querySelector('[data-gm-rtitle]');
      if (head && head.focus) head.focus();
    }

    root.querySelector('[data-gm-restart]').addEventListener('click', function () {
      step = 0;
      scores = {};
      history = [];
      root.classList.remove('is-done');
      render();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-gm-quiz]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
